// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-aboutpage-js": () => import("/opt/build/repo/src/pages/aboutpage.js" /* webpackChunkName: "component---src-pages-aboutpage-js" */),
  "component---src-pages-contactus-js": () => import("/opt/build/repo/src/pages/contactus.js" /* webpackChunkName: "component---src-pages-contactus-js" */),
  "component---src-pages-copperrepipepage-js": () => import("/opt/build/repo/src/pages/copperrepipepage.js" /* webpackChunkName: "component---src-pages-copperrepipepage-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-servicespage-js": () => import("/opt/build/repo/src/pages/servicespage.js" /* webpackChunkName: "component---src-pages-servicespage-js" */),
  "component---src-pages-terms-js": () => import("/opt/build/repo/src/pages/terms.js" /* webpackChunkName: "component---src-pages-terms-js" */)
}

